import pulse from '@finn-no/pulse-sdk';

/*
 * BAP_ev10
 * TJT: Click on "Mer om fiks ferdig" on ad pages, replaces BAP_ev02
 */
export const trackMoreAboutFiksFerdig = (finnkode: string) =>
    pulse.trackEvent({
        type: 'Click',
        intent: 'Open',
        name: 'Transaction journey torget',
        object: {
            id: 'mer-om-fiks-ferdig',
            type: 'UIElement',
            elementType: 'Button',
            name: 'Ad pages',
            items: [
                {
                    type: 'ClassifiedAd',
                    id: finnkode,
                    contentId: finnkode,
                    name: 'n/a',
                    category: 'n/a',
                },
            ],
        },
        target: {
            id: finnkode,
            type: 'Article',
            name: 'Fiks ferdig',
        },
        vertical: {
            name: 'bap',
        },
    });

/*
 * BAP_ev03
 * TJT: Click on "shipping alternatives" on ad page
 */
export const trackShippingAlternatives = (finnkode: string) =>
    pulse.trackEvent({
        type: 'Click',
        intent: 'Open',
        name: 'More about shipping',
        object: {
            id: 'tjt-alternatives',
            type: 'UIElement',
            elementType: 'Link',
            items: [
                {
                    type: 'ClassifiedAd',
                    id: finnkode,
                    contentId: finnkode,
                    name: 'n/a',
                    category: 'n/a',
                },
            ],
        },
        target: {
            id: finnkode,
            type: 'Page',
            name: 'Fraktalternativer',
            pageType: 'product_description',
        },
        vertical: {
            name: 'bap',
        },
    });
